import { Inbox } from 'lucide-react';

const EmptyState = ({
  icon: Icon = Inbox,
  title = 'Nothing here yet',
  description = 'Create your first item to get started.',
  primaryAction,
  secondaryAction,
}) => {
  return (
    <div className="w-full py-14 px-6 flex flex-col items-center text-center bg-white dark:bg-slate-800 border dark:border-[#c4c4c432] rounded-md">
      <div className="h-12 w-12 rounded-full bg-primaryBlue/10 text-primaryBlue flex items-center justify-center mb-4">
        <Icon className="h-6 w-6" />
      </div>
      <div className="text-lg font-semibold text-gray-900 dark:text-white">
        {title}
      </div>
      <div className="mt-2 text-sm text-gray-600 dark:text-gray-400 max-w-md">
        {description}
      </div>
      {(primaryAction || secondaryAction) && (
        <div className="mt-6 flex items-center gap-3">
          {secondaryAction && (
            <button
              type="button"
              onClick={secondaryAction.onClick}
              className="px-4 py-3 text-xs border border-[#c4c4c460] rounded-md text-primaryBlue bg-white dark:bg-slate-700 dark:text-white"
            >
              {secondaryAction.label}
            </button>
          )}
          {primaryAction && (
            <button
              type="button"
              onClick={primaryAction.onClick}
              className="px-4 py-3 text-xs rounded-md text-white bg-primaryBlue"
            >
              {primaryAction.label}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyState;

